enum ProcessEnvironment {
  DEV = "dev",
  STAGING = "staging",
  PRODUCTION = "prod",
}

export default ProcessEnvironment;
